/**
 * Capitalizes a string.
 *
 * @param {String} value
 *
 * @return {String}
 */
export const capitalize = (value: string | null): string => {
  if (!value) {
    return '';
  }

  value = value.toString();

  return value.charAt(0).toUpperCase() + value.slice(1);
};
